export default {
  methods: {
    getExportTable () {
      return document.querySelector('#table_' + this.$refs.table.tableId)
    }
  }
}
